<template>
  <el-dialog
    :title="$t('housekeepingType.editTitle')"
    :visible.sync="dialogVisible"
    width="70%"
    @close="handleClose"
  >
    <el-form
      ref="form"
      :model="editHousekeepingTypeInfo"
      label-width="120px"
      label-position="right"
    >
      <el-form-item
        :label="$t('housekeepingType.typeName')"
        prop="hktName"
        :rules="[
          { required: true, message: $t('housekeepingType.typeNameRequired'), trigger: 'blur' },
          { max: 30, message: $t('housekeepingType.typeNameMaxLength'), trigger: 'blur' }
        ]"
      >
        <el-input
          v-model="editHousekeepingTypeInfo.hktName"
          :placeholder="$t('housekeepingType.typeNamePlaceholder')"
        />
      </el-form-item>

      <el-form-item
        :label="$t('housekeepingType.smallIcon')"
        prop="hktIcon"
        :rules="[
          { required: true, message: $t('housekeepingType.iconRequired'), trigger: 'change' }
        ]"
      >
        <upload-image
          ref="uploadImage"
          :image-count="1"
          :default-images="[editHousekeepingTypeInfo.hktIcon]"
          @upload-success="handleUploadSuccess"
        />
      </el-form-item>

      <el-form-item
        :label="$t('housekeepingType.serviceDesc')"
        prop="hktDesc"
        :rules="[
          { max: 50, message: $t('housekeepingType.serviceDescMaxLength'), trigger: 'blur' }
        ]"
      >
        <el-input
          v-model="editHousekeepingTypeInfo.hktDesc"
          :placeholder="$t('housekeepingType.serviceDescPlaceholder')"
        />
      </el-form-item>

      <el-form-item
        :label="$t('housekeepingType.label')"
        prop="label"
        :rules="[
          { max: 15, message: $t('housekeepingType.labelMaxLength'), trigger: 'blur' }
        ]"
      >
        <el-input
          v-model="editHousekeepingTypeInfo.label"
          :placeholder="$t('housekeepingType.labelPlaceholder')"
        />
      </el-form-item>

      <el-form-item
        :label="$t('housekeepingType.sort')"
        prop="seq"
        :rules="[
          { required: true, message: $t('housekeepingType.sortRequired'), trigger: 'blur' },
          { type: 'number', message: $t('housekeepingType.sortNumber'), trigger: 'blur' }
        ]"
      >
        <el-input
          v-model.number="editHousekeepingTypeInfo.seq"
          :placeholder="$t('housekeepingType.sortPlaceholder')"
        />
      </el-form-item>

      <el-form-item
        :label="$t('housekeepingType.showStatus')"
        prop="isShow"
        :rules="[
          { required: true, message: $t('housekeepingType.showStatusRequired'), trigger: 'change' }
        ]"
      >
        <el-select
          v-model="editHousekeepingTypeInfo.isShow"
          :placeholder="$t('housekeepingType.showStatusPlaceholder')"
          style="width:100%"
        >
          <el-option
            v-for="item in editHousekeepingTypeInfo.isShows"
            :key="item.statusCd"
            :label="item.name"
            :value="item.statusCd"
          />
        </el-select>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="updateHousekeepingTypeInfo">
        {{ $t('common.save') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getDict } from '@/api/shop/shopApi'
import { updateHousekeepingType } from '@/api/housekeeping/housekeepingTypeApi'
import UploadImage from '@/components/system/UploadImageUrl'
export default {
  name: 'EditHousekeepingType',
  components: {
    UploadImage
  },
  data() {
    return {
      dialogVisible: false,
      editHousekeepingTypeInfo: {
        hktId: '',
        hktName: '',
        hktIcon: '',
        hktDesc: '',
        label: '',
        seq: '',
        isShow: '',
        isShows: []
      }
    }
  },
  methods: {
    open(row) {
      this.dialogVisible = true
      this.editHousekeepingTypeInfo = {
        ...row,
        isShows: []
      }
      this.getDictData()
    },
    async getDictData() {
      try {
        const {data} = await getDict('housekeeping_type', 'is_show')
        this.editHousekeepingTypeInfo.isShows = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    handleUploadSuccess(urls) {
      if (urls.length > 0) {
        this.editHousekeepingTypeInfo.hktIcon = urls[0]
      } else {
        this.editHousekeepingTypeInfo.hktIcon = ''
      }
    },
    handleClose() {
      this.$refs.form.resetFields()
      this.editHousekeepingTypeInfo = {
        hktId: '',
        hktName: '',
        hktIcon: '',
        hktDesc: '',
        label: '',
        seq: '',
        isShow: '',
        isShows: []
      }
    },
    async updateHousekeepingTypeInfo() {
      try {
        await this.$refs.form.validate()
        const res = await updateHousekeepingType(this.editHousekeepingTypeInfo)
        if (res.code === 0) {
          this.$message.success(this.$t('common.saveSuccess'))
          this.dialogVisible = false
          this.$emit('refresh')
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('更新失败:', error)
      }
    }
  }
}
</script>